<template>
  <div>
    <!-- BEGIN: Modal Content -->
    <div id="edit-member-modal" class="modal" data-backdrop="static">
      <div class="modal-dialog modal-xl">
        <div class="modal-content bg-theme-39">
          <a data-dismiss="modal" href="javascript:;" @click="cancelModalForm">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <h3 class="text-theme-1 font-semibold text-md">
              แก้ไขข้อมูล{{currentTab}}
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
             <component :is="stepComponent" :is-modal="true" :cancel-modal="cancelData" :open-modal="openModalStatus" :edit-data="editData" @update-state="updateChange" @cancel-button="cancelModalForm"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Modal Content -->
  </div>
</template>
<script>
import { defineComponent, computed, ref, watch } from 'vue'
import Step2 from "@/components/member-wizard/step-2/index.vue"
import Step3 from "@/components/member-wizard/step-3/index.vue"
import Step4 from "@/components/member-wizard/step-4/index.vue"
import Step5 from "@/components/member-wizard/step-5/index.vue"

export default defineComponent({
  props:{
    currentTab: String,
    editData: Object,
    openModalStatus: Boolean
  },
  setup(props, {emit}) {
    const stepComponent = computed(() => {
      let tabValue
      if(props.currentTab == "รายได้"){
        tabValue = Step2
      }
      else if(props.currentTab == "สุขภาพ"){
        tabValue = Step3
      }
      else if(props.currentTab == "สวัสดิการ"){
        tabValue = Step4
      }
      else{
        tabValue = Step5
      }
      return tabValue
    })
    const cancelData = ref(false)

    function updateChange(){
      emit('updateProfile')
      emit('clearModalValue')
    }
    function cancelModalForm(){
      cancelData.value = true
      emit('clearModalValue')
    }
    watch(()=>props.openModalStatus,(val)=>{
      if(val){
        cash('#edit-member-modal').modal("show")
        cancelData.value = false
      }
    })
    return{
      stepComponent,
      updateChange,
      cancelModalForm,
      cancelData
    }
  },
})
</script>

